import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';
import { wrapFetch } from '#/fetch-wrapper';

/*
 * UNIT TYPES
 */

const upsertUnitTypes = payload => wrapFetch(() => api.post('/unit-types', payload));

const deleteUnitTypes = id => wrapFetch(() => api.delete(`/unit-types/${id}`));

const fetchUnitTypes = async propertyId => {
    if (propertyId) {
        const { data } = await api.get(`/unit-types/${propertyId}`);

        return data;
    }

    return {};
};

const fetchUnitNumberAndTypes = async propertyId => {
    if (propertyId) {
        const { data } = await api.get(`/units/${propertyId}`);

        return data;
    }

    return {};
};

export const useAllUnitTypes = (propertyId, queryOptions = {}) => useQuery(
    ['unitTypes', propertyId],
    () => fetchUnitTypes(propertyId),
    queryOptions
);

export const useUpsertUnitTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => upsertUnitTypes(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
        },
        ...queryOptions
    });
};

export const useDeleteUnitTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(id => deleteUnitTypes(id), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
        },
        ...queryOptions
    });
};

export const useUnitTypes = (propertyId, queryOptions = {}) => useQuery(
    ['unitGroupings', propertyId],
    () => unitTypes(propertyId),
    queryOptions
);

const unitTypes = async propertyId => {
    if (propertyId) {
        const { data } = await api.get(`/unit-types/${propertyId}/reports`);

        return data;
    }

    return {};
};

const makeReportPricing = async propertyId => {
    const { data } = await api.get(`/unit-types/${propertyId}/pricing`);

    return data;
};

export const useMakeReportPricing = (propertyId, queryOptions = {}) => useQuery(
    ['property', propertyId],
    () => makeReportPricing(propertyId),
    queryOptions
);

export const useGetDynamicUnitTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ propertyId }) => fetchUnitNumberAndTypes(propertyId),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('unitGroupings');
            },
            ...queryOptions
        }
    );
};
